import React, { useCallback, useState } from 'react'
import GrinMenu from 'components/common/menu/GrinMenu'
import { Eye } from 'components/common/icons'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'
import IconAndText from 'components/common/IconAndText'
import { ButtonBase } from '@material-ui/core'
import NoteVisibilityMenuItem from '../NoteVisibilityMenuItem'

const NoteItemVisiblityMenu = ({
  id,
  triggerLabelClassName = '',
  currentVisibilityLabel,
  visibilityOptions = [],
  onVisibilitySelected = () => {},
  disabled
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleVisibilitySelected = useCallback(
    value => {
      onVisibilitySelected(value)
      setIsOpen(false)
    },
    [onVisibilitySelected]
  )

  return (
    <GrinMenu
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      open={isOpen}
      triggerComponent={
        <ButtonBase disabled={disabled} id={id}>
          <IconAndText
            icon={<Eye color="rgba(114, 123, 140, 1)" />}
            text={<DazzedParagraph12 className={triggerLabelClassName}>{currentVisibilityLabel}</DazzedParagraph12>}
          />
        </ButtonBase>
      }
    >
      {visibilityOptions.map(option => (
        <NoteVisibilityMenuItem
          key={option.id}
          option={option}
          onClick={() => handleVisibilitySelected(option.value)}
        />
      ))}
    </GrinMenu>
  )
}

export default NoteItemVisiblityMenu
